var _classCallCheck = require("E:\\project\\lesterlyu.github.io\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("E:\\project\\lesterlyu.github.io\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

/**
 * Represents unions.
 * (A1, A1:C5, ...)
 */
var Collection = /*#__PURE__*/function () {
  "use strict";

  function Collection(data, refs) {
    _classCallCheck(this, Collection);

    if (data == null && refs == null) {
      this._data = [];
      this._refs = [];
    } else {
      if (data.length !== refs.length) throw Error('Collection: data length should match references length.');
      this._data = data;
      this._refs = refs;
    }
  }

  _createClass(Collection, [{
    key: "add",

    /**
     * Add data and references to this collection.
     * @param {{}} obj - data
     * @param {{}} ref - reference
     */
    value: function add(obj, ref) {
      this._data.push(obj);

      this._refs.push(ref);
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    }
  }, {
    key: "refs",
    get: function get() {
      return this._refs;
    }
  }, {
    key: "length",
    get: function get() {
      return this._data.length;
    }
  }]);

  return Collection;
}();

module.exports = Collection;